import { ChangeEvent, useEffect, useState } from 'react';

// onChangeに関するstate
type OnChangeState = {
  serialHead: boolean;
  first: boolean;
  second: boolean;
  third: boolean;
  fourth: boolean;
};

// 本カスタムフックの返り値
export type UseInputSerialValue = {
  inputSerialOnChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isNextButtonDisable: boolean; // [次へ進む]ボタンの状態
};

const useInputSerial = (): UseInputSerialValue => {
  // state
  // 各入力欄完了状態
  const [completes, setCompletes] = useState<OnChangeState>({
    serialHead: false,
    first: false,
    second: false,
    third: false,
    fourth: false,
  });

  // [次へ進むボタン]の状態
  const [isNextButtonDisable, setIsNextButtonDisable] =
    useState<boolean>(false);

  // 各入力欄の変更処理
  const inputSerialOnChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { target } = event;
    const { name } = target;
    setCompletes({ ...completes, [name]: target.validity.valid });
  };

  // [次へ進む]ボタンの状態
  useEffect(() => {
    setIsNextButtonDisable(
      !completes.serialHead ||
        !completes.first ||
        !completes.second ||
        !completes.third ||
        !completes.fourth,
    );
  }, [completes]);

  return {
    inputSerialOnChange,
    isNextButtonDisable,
  };
};
export default useInputSerial;
